import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable-pfe'
import logo from './logo.png'
import computeColumnWidths from "../computeColumnWidths";
import generateCutoff from "utils/generateCutoff";

function footer(doc, height, width, padding, lineHeight) {
    doc.text(height - padding, width - (lineHeight + 4), 'SYZYGY STAFFING RESOURCES AGENCY CORPORATION', { align: 'right' }).setFont(undefined, 'bold');
    doc.text(height - padding, width - (lineHeight), '#PAYROLL AND BILLING DIVISION', { align: 'right' }).setFont(undefined, 'bold');

}

function header(doc, x, y, logoWidth, logoHeight) {
    doc.addImage(logo, 'PNG', x, y, logoWidth, logoHeight)
}

function persons(doc, currentLineCoordinate, documentHeight, documentPadding, lineHeight, persons = []) {

    //we use height as it is landscape
    let personsWidth = (documentHeight) / persons.length
    let coordinates = Array.from({ length: persons.length }, (_, i) => {
        let xCoordinates = documentPadding + (i * personsWidth);
        let yCoordinates = currentLineCoordinate + lineHeight * 2;

        return {
            task: {
                x: xCoordinates,
                y: yCoordinates
            },
            assignee: {
                x: xCoordinates,
                y: yCoordinates + lineHeight
            },
            position: {
                x: xCoordinates,
                y: yCoordinates + lineHeight * 1.5
            }
        }

    })



    coordinates.forEach((coord, index) => {
        let person = persons[index] || {};
        doc.text(0, 0, '').setFont(undefined, 'bold');
        doc.text(coord.task.x, coord.task.y, String(person.task).toUpperCase()).setFont(undefined, 'bold');
        doc.text(coord.assignee.x, coord.assignee.y, String(person.assignee).toUpperCase()).setFont(undefined, 'bold');
        doc.text(coord.position.x, coord.position.y, String(person.position).toUpperCase()).setFont(undefined, 'bold');
    })
}

function addPage(doc, topCenter, imageY, logoWidth, logoHeight, height, width, padding, lineHeight) {
    header(doc, topCenter, imageY, logoWidth, logoHeight)
    footer(doc, height, width, padding, lineHeight)
}


function ifTwoTablesExceedsPageLimit(hoursTableRows, payrollTableRows, rowPerPage) {
    return (hoursTableRows + payrollTableRows) > rowPerPage
}


export default async function (payrollOfficer = 'payroll officer', payrollManager = 'payroll manger', directorFinanceDept = 'director finance dept', president = 'president', cutoff = 'cutoff', store = 'sample store', payrollFrom = '', payrollTo = '') {
    //concatenating from and to for the cutoff
    cutoff = generateCutoff(payrollFrom, payrollTo)
    let padding = 13
    let width = 216
    let height = 330.2

    let middleCoordinate = (height - (padding * 2)) / 2
    let logoHeight = 20
    let logoWidth = 90
    let lineHeight = 8 // Adjust as needed
    let footerSpace = 50
    let currentLineCoordinate = 0
    let imageY = padding / 2
    let rowPerPage = 35



    const doc = new jsPDF({
        orientation: 'landscape',
        format: [height, width]
    })

    doc.setFontSize(7)
    header(doc, middleCoordinate - (logoWidth / 2), imageY, logoWidth, logoHeight)
    currentLineCoordinate += logoHeight + imageY; // Adjust for logo height and padding

    doc.text(padding, currentLineCoordinate, 'SUMMARY OF BILLING STATEMENT').setFont(undefined, 'bold');
    currentLineCoordinate += 2.5; // Move down a bit for the next content
    doc.text(padding, currentLineCoordinate, cutoff).setFont(undefined, 'bold');
    currentLineCoordinate += 2.5; // Move down a bit for the next content
    doc.text(padding, currentLineCoordinate, store).setFont(undefined, 'normal');

    //compute table styles for hours table
    let hoursTable = document.getElementById('hours_table')
    let hoursTableColumnCount = hoursTable.querySelectorAll('thead tr th').length
    let hoursTableColumnStyles = computeColumnWidths(hoursTableColumnCount, 30, 30, height - (padding * 2))


    let payrollTable = document.getElementById('payroll_table')
    //hours table
    autoTable(doc, {
        useCss: true,
        html: '#hours_table',
        margin: {
            bottom: 30,
            top: 40
        },
        columnStyles: hoursTableColumnStyles,
        styles: {
            fontSize: 4,
            lineWidth: 0.1,
            cellPadding: 0.5,
            overflow: 'linebreak',
        },
        //horizontalPageBreak: true,
        //horizontalPageBreakRepeat: 0,
        //horizontalPageBreakBehaviour: 'afterAllRows',
        theme: 'plain',
        willDrawCell: function (data) {
        },
        didDrawPage: function (data) {
            header(doc, middleCoordinate - (logoWidth / 2), imageY, logoWidth, logoHeight)
            footer(doc, height, width, padding, lineHeight)
        }
    })

    let hoursTableRows = hoursTable.querySelectorAll('tbody tr').length
    let payrollTableRows = payrollTable.querySelectorAll('tbody tr').length

    //check if hours table rows and payroll table rows exceeds the row per page limit, if it does add a page break
    //we subtract 5 from the row per page limit to account for the header and footer and some padding
    if (ifTwoTablesExceedsPageLimit(hoursTableRows, payrollTableRows, rowPerPage - 5)) {
        doc.addPage()
    }




    //get the number of columns in the payroll table
    let columnCount = payrollTable.querySelectorAll('thead tr th').length
    //payroll table

    let payrollTableColumnStyles = computeColumnWidths(columnCount, 30, 30, height - (padding * 2))

    autoTable(doc,
        {
            html: '#payroll_table',
            tableWidth: width - (padding * 2),
            margin: {
                top: 40
            },
            styles: {
                overflow: 'linebreak',
            },
            useCss: true,
            //horizontalPageBreak: true,
            //horizontalPageBreakRepeat: 0,
            //horizontalPageBreakBehaviour: 'afterAllRows',
            styles: {
                overflow: 'linebreak',
                minCellWidth: 10,
            },
            columnStyles: payrollTableColumnStyles,
            theme: 'plain',
            willDrawCell: function (data) {
                // ...existing code...
            },
            didDrawPage: function (data) {
                console.log('draw page', data)
                //data.cursor.y = 500; // Set this to your desired top margin value
                header(doc, middleCoordinate - (logoWidth / 2), imageY, logoWidth, logoHeight)
                // Draw the header and footer on each page
                //footer(doc, height, width, padding, lineHeight)
            }
        })

    doc.addPage()

    autoTable(doc, {
        useCss: true,
        offsetY: 20,
        html: '#billing_details_table',
        theme: 'plain',
        tableWidth: 'wrap',
        didDrawPage: function (data) {
            console.log('draw page', data)
            header(doc, middleCoordinate - (logoWidth / 2), imageY, logoWidth, logoHeight)
            //doc.addImage(logoBase64, 'PNG', middleCoordinate - (logoWidth / 2), imageY, logoWidth, logoHeight)
            // Draw the header and footer on each page
            footer(doc, height, width, padding, lineHeight)
        }
    })

    persons(doc, doc.lastAutoTable.finalY, height, padding, lineHeight, [
        {
            task: 'PREPARED BY: ',
            assignee: payrollOfficer,
            position: 'Payroll Head'
        }, {
            task: 'CHECKED: ',
            assignee: payrollManager,
            position: 'Payroll Manager'
        }, {
            task: 'APPROVED: ',
            assignee: president,
            position: 'President'
        }, {
            task: 'NOTED: ',
            assignee: directorFinanceDept,
            position: 'Director Finance Dept. '
        }
    ])



    let blob = doc.output('bloburl')
    window.open(blob)

    return


}

